import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormBuilder, FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { ImageProcessComponent } from '../../components/modal/image-process/image-process.component';
import { AlertComponent } from 'src/app/components/modal/alert/alert.component';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { OrderService } from 'src/app/service/order.service';
import { ConfirmChangeEmailComponent } from 'src/app/components/modal/confirm-change-email/confirm-change-email.component';
import { EmailChangeFailComponent } from 'src/app/components/modal/email-change-fail/email-change-fail.component';
import { DeleteGedcomComponent } from 'src/app/components/modal/delete-gedcom/delete-gedcom.component';
import { EmailSubscribeComponent } from 'src/app/components/modal/email-subscribe/email-subscribe.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profileForm = this.fb.group({
    avatar: new FormControl(''),
    emailReferens: new FormControl(''),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    address: new FormControl(''),
    zipcode: new FormControl(''),
    city: new FormControl(''),
    country: new FormControl('', Validators.required),
    province: new FormControl(''),
    phone: new FormControl(''),
    company: new FormControl(''),
    vat: new FormControl(''),
    newsletter: new FormControl(''),
  });
  userId: string;
  avatar: any = './assets/image/profile.svg'
  profileData: any;
  countries: any = [];
  //declaring province to avoid error
  selectedCountry: any = {
    province: []
  };
  provinces: any = [];

  totalCols = 11
  addressCols = 6
  addressRows = 10
  newsletterCols = 5
  newsletterRows = 3
  otherCols = 5
  otherRows = 7
  imgURL
  organization: any = {
    id: '',
    name: '',
    discountCodeId: '',
    url:''
  }
  discount: any;

  useremail: string = null;
  uid: string;
  profileUrl: any;
  downloadURL: any;
  changeEmail: any
  constructor(
    public matDialog: MatDialog,
    // public dialogRef: MatDialogRef<ProfileComponent>,
    private profileService: ProfileService, 
    private afs: AuthService,
    private orderService: OrderService,
    private fb: FormBuilder,
    private storage: AngularFireStorage
  ) { }


  resetPassword() {
    this.afs.resetPassword(this.useremail).then(
      () => alert('A password reset link has been sent to your email address'),
      (rejectionReason) => alert(rejectionReason))
      .catch(e => alert('An error occurred while attempting to reset your password'));
  }

  imageProcess() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "image-process-component";
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      type: 'node-avatar'
    }
    const modalDialog = this.matDialog.open(ImageProcessComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.avatar = result;
        const filePath = `profiles/${this.uid}`;
        const ref = this.storage.ref(filePath);
        
        ref.putString(result.split('data:image/png;base64,')[1], 'base64').then(function (snapshot) {
        }, err => console.log(err))
      }
    });
  }

  newsletter(newsletter){
    if(newsletter){

      const dialogConfig = new MatDialogConfig();
      // The user can't close the dialog by clicking outside its body
      dialogConfig.disableClose = true;
      dialogConfig.id = "alert-component";
      dialogConfig.data = {
        subscribe: newsletter
      }
      const modalDialog = this.matDialog.open(EmailSubscribeComponent, dialogConfig);
      
      modalDialog.afterClosed().subscribe((result) => {
        if (result == 'success') {
          this.profileForm.value.newsletter = newsletter
          this.profileService.updateProfile({newsletter: this.profileForm.value.newsletter}).then((res) => {
          }, err => console.log(err)) // Show err
        }
      });
    }
    else{
      this.profileForm.value.newsletter = newsletter
      this.profileService.updateProfile({newsletter: this.profileForm.value.newsletter}).then((res) => {
      }, err => console.log(err)) // Show err
    }
  }

  dissableAccount(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "alert-component";
    dialogConfig.data = {
      title: 'Delete Account',
      message: "Are you sure you want to delete your account?"
    }
    const modalDialog = this.matDialog.open(AlertComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result == 'success') {
        this.profileService.updateProfile({dissableAccount: true, dissableDate: new Date() }).then((res) => {
        }, err => console.log(err)) // Show err
        window.location.reload();
      }
    });
  }

  updateEmail(email){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "alert-component";
    dialogConfig.data = {
      email: email,
    }
    const modalDialog = this.matDialog.open(ConfirmChangeEmailComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result == 'success') {
        this.afs.updateProfileEmail(email)
          .then((res) => {
            this.afs.SignOut();
          })
          .catch((error) => {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.id = "alert-component";
            const modalDialog = this.matDialog.open(EmailChangeFailComponent , dialogConfig);
          });
      }
    });
  }

  updateProfile() {
    console.log(this.profileForm.value)
    this.profileService.updateProfile(this.profileForm.value).then((res) => {
    }, err => console.log(err)) // Show err
  }

  onResize(event) {
    if (event.target.innerWidth > 768) {
      this.totalCols = 11
      this.addressCols = 6
      this.addressRows = 8
      this.newsletterCols = 5
      this.newsletterRows = 3
      this.otherCols = 5
      this.otherRows = 5
    }
    else if (event.target.innerWidth <= 768) {
      this.totalCols = 11
      this.addressCols = 11
      this.addressRows = 10
      this.newsletterCols = 11
      this.newsletterRows = 3
      this.otherCols = 11
      this.otherRows = 5
    }
  }

  onChanges(): void {
    this.profileForm.get('country').valueChanges.subscribe(country =>{
      this.countries.forEach(element => {
        if(element.country == country){
          this.selectedCountry = element;
        }
      });
      if(this.selectedCountry.province.length <= 0){
        this.profileForm.patchValue({
          province: ''
        });
      }
      else{
        this.profileForm.patchValue({
          province: this.selectedCountry.province[0].name
        });
      }
    })
  }

  ngOnInit(): void {

    if (window.innerWidth <= 768) {
      this.totalCols = 11
      this.addressCols = 11
      this.addressRows = 10
      this.newsletterCols = 11
      this.newsletterRows = 3
      this.otherCols = 11
      this.otherRows = 5
    }

    this.orderService.getCountries().then((ca: any) => {
      let countries = ca.sort((a, b) => (a.country < b.country) ? -1 : 1);
      
      this.orderService.getProvinces().then((res: any) => {
        this.provinces = res.sort((a, b) => (a.name < b.name) ? -1 : 1);;
        countries.forEach(country => {
          country.province = [];
          this.provinces.forEach(province => {
            if(country.alpha2_code == province.alpha2_code){
              country.province.push(province);
            }
          });
          this.countries.push(country)
        });
      });
    }, err => {
      console.log(err)
    } // Show error
    )

    this.profileService.getUserProfile().subscribe((profile: any) => {
      const profileData = profile.payload.data();
      this.uid = profileData.uid
      this.useremail = profileData.email;
      this.profileForm.patchValue(
        {
          firstName: profileData.firstName || '',
          lastName: profileData.lastName || '',
          address: profileData.address || '',
          zipcode: profileData.zipcode || '',
          city: profileData.city || '',
          country: profileData.country || '',
          phone: profileData.phone || '',
          company: profileData.company || '',
          vat: profileData.vat || '',
          newsletter: profileData.newsletter || false,
        }
      );
      this.userId = profileData.uid
      
      if(profileData.oid){
        this.orderService.getOrganizationByid(profileData.oid).then((response: any) =>{
          this.organization = {
            id: response[0].id,
            name: response[0].name,
            discountCodeId: response[0].discountCodeId,
            url: response[0].url
          }

          this.orderService.getDiscounts().then((response: any) =>{
            response.forEach(element => {
              if(this.organization.discountCodeId == element.id){
                return this.discount = element;
              }
            });
          }, err => {
            console.log(err)
          })
        })
      }
      
      const ref = this.storage.ref(`profiles/${this.uid}`);
      this.downloadURL = ref.getDownloadURL().subscribe((res) => {
        console.log(res)
        this.avatar = res;
      })

    }, err => {
      console.log(err)
    })
    this.onChanges();
  }

  get firstName() { return this.profileForm.get('firstName'); }
  get lastName() { return this.profileForm.get('lastName'); }
  get country() { return this.profileForm.get('country'); }


}
